export function initVW(base = 375) {
    const update = () => {
        const width = window.innerWidth
        document.documentElement.style.fontSize = (width / base * 100) + 'px'
    }
    update()
    window.addEventListener('resize', update)
}